import { useState } from 'react';
import { createProviderConnectionWithCredentials } from 'Services/providersConnections';
import PropTypes from 'prop-types';
import ProviderConnectionConnectWithCredentialsLogin from './ProviderConnectionConnectWithCredentialsLogin';
import { useErrors } from 'Components/Organisms/ErrorsProvider';

export default function ProviderConnectionConnectWithCredentials(props) {
    const {
        providerLogoUrl,
        providerName,
        providerConnectionId,
        connectorId,
        connectorMeta,
        onConnect,
        onCancel,
        serviceId,
    } = props;
    const [processing, setProcessing] = useState(false);
    const { showUnknownError } = useErrors();

    const handleSubmit = async (data) => {
        setProcessing(true);
        const { documentType, credentials } = data;
        try {
            const conexionId = await createProviderConnectionWithCredentials({
                connectorId,
                name: providerName,
                providerConnectionId,
                credentials,
                documentType,
            });

            onConnect(conexionId, credentials);
        } catch (error) {
            showUnknownError(error);
            onCancel();
        } finally {
            setProcessing(false);
        }
    };

    return (
        <div className="text-center p-4 mb-4">
            <div className="flex items-center justify-center mb-12">
                <img src={providerLogoUrl} alt={providerName} className="w-16 h-auto block" />
                <h2 className="mb-0 text-2xl md:text-3xl text-pretty font-semibold">{providerName}</h2>
            </div>

            <ProviderConnectionConnectWithCredentialsLogin
                fieldsNames={connectorMeta.fields_names}
                fieldsDescriptions={connectorMeta.fields_descriptions}
                fieldsTypes={connectorMeta.fields_types}
                documentTypes={connectorMeta.document_types}
                processing={processing}
                serviceId={serviceId}
                onSubmit={handleSubmit}
            />
        </div>
    );
}

ProviderConnectionConnectWithCredentials.propTypes = {
    connectorId: PropTypes.string.isRequired,
    providerName: PropTypes.string.isRequired,
    providerLogoUrl: PropTypes.string.isRequired,
    connectorMeta: PropTypes.object.isRequired,
    onConnect: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    providerConnectionId: PropTypes.string,
    serviceId: PropTypes.string,
};
